<template v-once>
  <img src="@/assets/icons/reachmd_icon.png" alt="reachmd icon">
</template>

<script>
export default {
  name: "ReachMD",
};
</script>

<style scoped>
</style>